import React, { useState, useEffect } from "react";
//@ts-ignore
import { LanguageContext } from "../../../../context/LanguageContext.jsx";
//@ts-ignore
import { dataList } from "../../../Admin/AdmMain";
import Page from "../../../Atomic/template/PageTable";
import CommonControl from "../../../Atomic/organism/CommonControl";
import { useNavigate } from "react-router-dom";
//@ts-ignore
import axios from "../../../../lib/axios";
//@ts-ignore
import { useAuth } from "../../../../context/LoginContext.jsx";
//@ts-ignore
import TableAtom from "../../../Atomic/organism/AtomTable";
import { filterData, inputChnage } from "../../../Atomic/exFunc";
import Form from "../../../Atomic/organism/FormAtom";
import moment from "moment";
//@ts-ignore
export default function Table() {
  //@ts-ignore
  const { language } = React.useContext(LanguageContext);
  const navi = useNavigate();
  const [rawData, setRawData] = useState<any>([]);
  const { user } = useAuth();
  const inputRef = React.createRef<HTMLInputElement>();
  const [keyword, setKeyword] = useState("");
  const [data, setData] = useState<any>([]);
  // Function defines
  //===============================================================
  function move(e: any) {
    const i = e.instance.store.focus.rowIndex;
    if (i === undefined) {
      return;
    }
    const idx = e.instance.store.data.rawData[i].idx;

    if (e.columnName !== "sms_cnt" && e.targetType != "columnHeader") {
      navi(`/Adm/def-table/edit`, {
        state: {
          idx: idx,
        },
      });
    }
  }

  function submitFun(e: any) {
    e.preventDefault();
    filterData(rawData, keyword, setData);
  }

  // Data define
  //===============================================================
  const fixFormat = (value : any) => {
    if(value == 1) {
      return language === 'KOR' ? '입고' : 'In Stock'
    } else if(value == 2) {
      return language === 'KOR' ? '출고' : 'Pre-realease'
    } else if(value == 3) {
      return language === 'KOR' ? '처리' : 'Processing'
    } else if(value == 4) {
      return language === 'KOR' ? '완료' : 'Complete'
    } else {
      return ""
    }
  }

  const columns: any = [
    {
      header: language === "KOR" ? "번호" : "Num",
      name: "rowKey" + 1,
      width: 70,
      align: "center",
      formatter: (name: any) => name.row.rowKey + 1,
    },
    {
      header: language === "KOR" ? "단말기번호" : "Device No",
      name: "unitid",
      align: "center",
    },
    {
      header: language === "KOR" ? "단말기명칭" : "Device Name",
      name: "d_nm",
      align: "center",
    },
    {
      header: language === "KOR" ? "접수일자" : "Date of receipt",
      name: "defect_ymd",
      align: "center",
      formatter: (item : any) => moment.utc(item.row.defect_ymd).format("YYYY-MM-DD")
    },
    {
      header:
        language === "KOR" ? "요청자(고객명)" : "Requester (customer name)",
      name: "defect_u_nm",
      align: "center",
    },
    {
      header: language === "KOR" ? "처리자" : "Person in charge",
      name: "fix_u_nm",
      align: "center",
    },
    {
      header: language === "KOR" ? "처리유무" : "Processing status",
      name: "fix_kind",
      align: "center",
      formatter: (item : any) => fixFormat(item.row.fix_kind)
    },
  ];

  const buttonData = [
    {
      labelKR: "전체목록",
      labelEN: "View All",
      classN: "white",
      clickFun: () => {
        setKeyword("");
      },
      position: "left",
      icon: false,
      iconClass: "",
    },
    {
      labelKR: "등록",
      labelEN: "Add new",
      classN: "purple",
      icon: true,
      clickFun: () => {
        navi("/Adm/def-table/new");
      },
      position: "right",
    },
  ];

  const formData = {
    lan: language,
    inputId: "keyword",
    type: "text",
    placeKR: "검색어를 입력하세요",
    placeEN: "Please enter a search term",
    submitHandler: submitFun,
    filter: (e: any) => inputChnage(e, rawData, setData, setKeyword),
    myref: inputRef,
    option: undefined, // Make option undefined
    value: keyword,
  };

  // useEffect define
  //===============================================================

  useEffect(() => {
    axios
      .get(
        `/web/admin/complain/list?type=${user.type}`
      )
      .then((res: any) => {
        setRawData(res.data);
      })
      .catch((err: any) => {
        console.log(err);
      });
  }, [user]);
  useEffect(() => {
    if (rawData && keyword === "") {
      setData(rawData);
    } else if (rawData && keyword !== "") {
      filterData(rawData, keyword, setData);
    }
  }, [rawData, keyword]);

  // logs define
  //===============================================================
  return (
    <>
      <Page
        language={language}
        dataList={dataList}
        title={`${language === "KOR" ? "고객불만관리" : "Customer Complaint"}`}
        menu="/Adm/def-table"
      >
        <Form formData={formData} inputRef={inputRef} />
        <TableAtom data={data} columns={columns} move={move} />
        <CommonControl buttonData={buttonData} language={language} />
      </Page>
    </>
  );
}
